import axiosClient from './axiosClient';

export const getCategories = () => axiosClient.get('/api/categories');

export const createCategory = (payload) => axiosClient.post('/api/categories', payload);

export const updateCategory = (id, payload) => axiosClient.put(`/api/categories/${id}`, payload);

export const deleteCategory = (id) => axiosClient.delete(`/api/categories/${id}`);
